import React, { useState, useEffect, useRef } from "react";
import Modal from "@mui/material/Modal";
import { IconButton } from "@mui/material";
import { Cancel, CameraEnhanceOutlined } from "@mui/icons-material";
import { useSpring, animated } from "@react-spring/web";
import galleryMessage from "../mock/galleryMessage";

// AHORA RECIBIMOS LA PROP isFormActive
const GalleryMessage = ({ isFormActive }) => {
  const [open, setOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  // Usamos useState para el estado de la animación
  const [scrollInterval, setScrollInterval] = useState(null);
  const [scrollPosition, setScrollPosition] = useState(0);

  // Usamos una ref para el contenedor del carrusel
  const containerRef = useRef(null);

  const modalFade = useSpring({
    opacity: open ? 1 : 0,
    config: { duration: 300 },
  });

  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
    setOpen(true);
  };

  const handleCloseModal = () => {
    setOpen(false);
    setSelectedImage(null);
  };

  // Función para iniciar el intervalo de scroll
  const startScrolling = () => {
    // Si ya existe un intervalo, no hacemos nada
    if (scrollInterval) return;

    const interval = setInterval(() => {
      setScrollPosition((prev) => {
        const container = containerRef.current;
        if (!container) return prev;
        const containerWidth = container.scrollWidth;
        const visibleWidth = container.clientWidth;
        const maxScroll = containerWidth - visibleWidth;
        // Reinicia si llega al final, de lo contrario, avanza
        return prev >= maxScroll ? 0 : prev + 1;
      });
    }, 30);
    setScrollInterval(interval);
  };

  // Función para detener el intervalo
  const stopScrolling = () => {
    if (scrollInterval) {
      clearInterval(scrollInterval);
      setScrollInterval(null);
    }
  };

  // El efecto principal que inicia/detiene el scroll
  useEffect(() => {
    if (isFormActive) {
      stopScrolling();
    } else {
      startScrolling();
    }
    // Función de limpieza para detener el intervalo al desmontar el componente
    return () => stopScrolling();
  }, [isFormActive]); // Se ejecuta cuando cambia `isFormActive`

  // Efecto para aplicar la posición de scroll al DOM
  useEffect(() => {
    const container = containerRef.current;
    if (container) {
      container.scrollLeft = scrollPosition;
    }
  }, [scrollPosition]);

  // Manejadores de eventos del mouse
  const handleMouseEnter = () => {
    stopScrolling();
  };

  const handleMouseLeave = () => {
    if (!isFormActive) {
      startScrolling();
    }
  };

  return (
    <section id="galleryMessage" className="scroll-mt-24 py-12">
      <div className="text-center lg:mb-8 mb-2 px-[5%]">
        <div className="inline-block relative group">
          <h2
            className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 via-pink-500 to-red-600 tracking-wide flex items-center justify-center gap-2"
            data-aos="zoom-in-up"
            data-aos-duration="600"
          >
            <CameraEnhanceOutlined
              className="w-6 h-6 text-yellow-400 animate-bounce mr-2"
              fontSize="large"
            />
            Retroalimentación de nuestros viajeros
            <CameraEnhanceOutlined
              className="w-6 h-6 text-yellow-400 animate-bounce ml-2"
              fontSize="large"
            />
          </h2>
        </div>
      </div>

      <div
        ref={containerRef}
        id="Carousel"
        className="gallery-message-container flex overflow-x-hidden space-x-4 py-4 rounded-x1"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {[...galleryMessage, ...galleryMessage].map((item, index) => (
          <img
            key={index}
            src={item.image}
            alt={`Imagen ${index + 1}`}
            onClick={() => handleImageClick(item.image)}
            className="flex-none w-80 h-auto cursor-pointer rounded-lg shadow-lg"
            style={{
              cursor: "pointer",
              outline: "none",
              transition: "transform 0.3s ease-in-out",
            }}
            onMouseOver={(e) =>
              (e.currentTarget.style.transform = "scale(1.05)")
            }
            onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
          />
        ))}
      </div>

      <Modal
        open={open}
        onClose={handleCloseModal}
        aria-labelledby="image-modal"
        aria-describedby="image-modal-description"
        className="flex justify-center items-center p-4 sm:p-6"
      >
        <animated.div
          style={{
            ...modalFade,
            maxWidth: "90vw",
            maxHeight: "90vh",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
            borderRadius: "16px",
            overflow: "hidden",
            backgroundColor: "white",
          }}
          className="shadow-lg"
        >
          <IconButton
            edge="end"
            color="inherit"
            onClick={handleCloseModal}
            aria-label="close"
            sx={{
              position: "absolute",
              top: 12,
              right: 12,
              backgroundColor: "white",
              borderRadius: "50%",
              zIndex: 10,
            }}
          >
            <Cancel />
          </IconButton>

          {selectedImage && (
            <img
              src={selectedImage}
              alt="Imagen seleccionada"
              style={{
                maxWidth: "100%",
                maxHeight: "calc(90vh - 48px)",
                objectFit: "contain",
                borderRadius: "16px",
              }}
            />
          )}
        </animated.div>
      </Modal>
    </section>
  );
};

export default GalleryMessage;
